import { MyHttpClient } from '../../app/http-client.service';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "../http-client.service";
var HostAdjustmentService = /** @class */ (function () {
    function HostAdjustmentService(http) {
        this.http = http;
        this.server = environment.server;
        this.orderBaseUrl = this.server + "/api/orders";
    }
    HostAdjustmentService.prototype.hostRefundDetails = function (orderId, adjustmentObj, role) {
        var requestBody = { adjustmentObj: adjustmentObj, role: role };
        return this.http.post(this.orderBaseUrl + "/" + orderId + "/refund", requestBody).pipe(catchError(this.handleError));
    };
    HostAdjustmentService.prototype.hostDebitDetails = function (orderId, adjustmentObj) {
        var requestBody = { adjustmentObj: adjustmentObj };
        return this.http.post(this.orderBaseUrl + "/" + orderId + "/captainRemarks", requestBody).pipe(catchError(this.handleError));
    };
    HostAdjustmentService.prototype.handleError = function (error) {
        if (error.error instanceof ErrorEvent) {
            console.error('An error occurred:', error.error.message);
        }
        else {
            console.error("Backend returned code " + error.status + ", body was: " + error.error);
        }
        return throwError(error);
    };
    HostAdjustmentService.ngInjectableDef = i0.defineInjectable({ factory: function HostAdjustmentService_Factory() { return new HostAdjustmentService(i0.inject(i1.MyHttpClient)); }, token: HostAdjustmentService, providedIn: "root" });
    return HostAdjustmentService;
}());
export { HostAdjustmentService };
